import { render, staticRenderFns } from "./CatelogItem.vue?vue&type=template&id=3a6a4356&"
import script from "./CatelogItem.vue?vue&type=script&lang=js&"
export * from "./CatelogItem.vue?vue&type=script&lang=js&"
import style0 from "./CatelogItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports